import React, { memo } from 'react';
import { IBaseSubscription } from 'reactApp/modules/subscriptions/subscriptions.types';
import { createGaSender } from 'reactApp/utils/ga';

import { SubscriptionItem } from '../SubscriptionListItem/SubscriptionListItem';

const sendGa = createGaSender('subs-sidebar');

type Props = {
    subscription: IBaseSubscription;
    onClick: () => void;
};

export const BaseSubscriptionItemComponent = memo<Props>(({ subscription, onClick }) => {
    const handleOnClick = () => {
        sendGa('click', 'subs-item', subscription.type);
        onClick();
    };

    return (
        <SubscriptionItem
            icon={subscription.icon}
            title={subscription.space.value}
            description="Основной объём Облака"
            onClick={handleOnClick}
        />
    );
});

BaseSubscriptionItemComponent.displayName = 'BaseSubscriptionItemComponent';
